import { getApp, getApps, initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  signInAnonymously,
} from "firebase/auth";
import { getDatabase } from "firebase/database";

let firebaseClientPromise;

// Firebase web configuration is public by design. Keeping a bundled fallback
// lets Capacitor's local https://localhost origin initialize without relying on
// Firebase Hosting's reserved /__/firebase/init.json endpoint.
const bundledConfig = {
  apiKey: "AIzaSyBdE33ZJrgFpkLFOvt5a0uEsio-VuS-_p8",
  appId: "1:675779272307:web:ed848f41f361486cd55406",
  authDomain: "hedone-d5f2f.firebaseapp.com",
  databaseURL: "https://hedone-d5f2f-default-rtdb.asia-southeast1.firebasedatabase.app",
  measurementId: "G-04G3G5NS02",
  messagingSenderId: "675779272307",
  projectId: "hedone-d5f2f",
  storageBucket: "hedone-d5f2f.firebasestorage.app",
};

const envConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

async function loadFirebaseConfig() {
  if (envConfig.apiKey && envConfig.databaseURL) return envConfig;

  try {
    const response = await fetch("/__/firebase/init.json");
    if (response.ok) return response.json();
  } catch (error) {
    // The reserved Hosting endpoint does not exist inside a bundled APK.
  }
  return bundledConfig;
}

export async function getFirebaseClient() {
  if (!firebaseClientPromise) {
    firebaseClientPromise = (async () => {
      const config = await loadFirebaseConfig();
      const app = getApps().length ? getApp() : initializeApp(config);
      const auth = getAuth(app);
      try {
        await setPersistence(auth, browserLocalPersistence);
      } catch (error) {
        console.warn("Firebase local auth persistence is unavailable", error);
      }
      if (typeof auth.authStateReady === "function") await auth.authStateReady();
      return {
        app,
        auth,
        database: getDatabase(app),
      };
    })();
  }

  return firebaseClientPromise;
}

export async function getFirebaseUser({ allowAnonymous = true } = {}) {
  const client = await getFirebaseClient();
  if (typeof client.auth.authStateReady === "function") await client.auth.authStateReady();
  if (client.auth.currentUser) {
    return { ...client, user: client.auth.currentUser };
  }
  if (!allowAnonymous) return { ...client, user: null };

  const credential = await signInAnonymously(client.auth);
  return { ...client, user: credential.user };
}
